import { render, staticRenderFns } from "./ImpactTopic.vue?vue&type=template&id=57ac2599&"
import script from "./ImpactTopic.vue?vue&type=script&lang=js&"
export * from "./ImpactTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports